/**
 * CollabLogo - Displays "HT x Company" collaboration branding
 *
 * Shows the Hollywood Trucks logo alongside a partner company logo
 * with an "x" separator between them, used for co-branded deployments.
 */

interface CollabLogoProps {
  partnerLogoUrl: string;
  partnerName: string;
  isDarkMode: boolean;
  size?: 'sm' | 'md';
}

const sizeConfig = {
  sm: {
    htHeight: 'h-5 sm:h-6',
    partnerHeight: 'h-7 sm:h-8',
    xSize: 'text-[9px] sm:text-[10px]',
    gap: 'gap-1 sm:gap-1.5',
    partnerMaxWidth: 'max-w-[80px] sm:max-w-[100px]',
  },
  md: {
    htHeight: 'h-8',
    partnerHeight: 'h-12',
    xSize: 'text-xs',
    gap: 'gap-2',
    partnerMaxWidth: 'max-w-[160px]',
  },
};

export function CollabLogo({ partnerLogoUrl, partnerName, isDarkMode, size = 'md' }: CollabLogoProps) {
  const { htHeight, partnerHeight, xSize, gap, partnerMaxWidth } = sizeConfig[size];

  return (
    <div className={`flex items-center ${gap} min-w-0`}>
      {/* HT Logo */}
      {isDarkMode ? (
        <img
          src="/assets/ht-logo.png"
          alt="Hollywood Trucks"
          className={`${htHeight} w-auto flex-shrink-0`}
        />
      ) : (
        <img
          src="/assets/ht_logo_white.png"
          alt="Hollywood Trucks"
          className={`${htHeight} w-auto flex-shrink-0`}
        />
      )}

      {/* "x" separator */}
      <span className={`${xSize} font-medium text-muted-foreground select-none flex-shrink-0`}>
        x
      </span>

      {/* Partner Logo */}
      <img
        src={partnerLogoUrl}
        alt={partnerName}
        className={`${partnerHeight} w-auto ${partnerMaxWidth} object-contain min-w-0`}
      />
    </div>
  );
}
